// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

//require('bootstrap-modal')

import $ from "jquery";
window.$ = window.jQuery = global.$ = global.jQuery = $;

import "jquery-validation";
import "bootstrap";
require("datatables.net-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-buttons-bs4");

import "../stylesheets/application.scss";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-scroller-bs4/css/scroller.bootstrap4.min.css";
import "packs/custom";
import "../custom/jquery-steps/jquery.steps.min";

const dataTableOptions = {
  pageLength: 50,
  paging: true,
  searching: true,
  info: true,
  lengthChange: true,
  pagingType: "simple_numbers",
  dom:
    "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
  language: {
    search: "Search:",
    lengthMenu: "_MENU_ records per page",
    info: "Showing _START_ to _END_ of _TOTAL_ records",
    infoEmpty: "No records available",
    zeroRecords: "Nothing found",
  },
};

const dataTables = [];
const initializeDataTable = (element, options = {}) => {
  if ($.fn.dataTable.isDataTable(element)) {
    return $(element).DataTable();
  }

  const dataTable = $(element).DataTable({
    ...dataTableOptions,
    ...options,
  });

  dataTables.push(dataTable);
  return dataTable;
};

window.initializeDataTable = initializeDataTable;

document.addEventListener("turbolinks:load", () => {
  $(".data-table").each((_, element) => initializeDataTable(element));
});

document.addEventListener("turbolinks:before-cache", () => {
  while (dataTables.length !== 0) {
    dataTables.pop().destroy();
  }
});

// src/application.js
import { Application } from "stimulus";
import { definitionsFromContext } from "stimulus/webpack-helpers";
const application = Application.start();
const context = require.context("controllers", true, /\.js$/);
application.load(definitionsFromContext(context));

document.addEventListener("turbolinks:load", () => {
  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="popover"]').popover();
});
//import "./custom";
//import  "./calc_units.js";
//import 'packs/calc_units';

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
